import { createContext } from 'react';

const InventoriesContext = createContext();

export default InventoriesContext;